/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/pages/auth/AuthPage`, `src/pages/home/HomePage`).
 */

import React from "react";
import { Redirect, Route, Switch, useLocation, withRouter } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import HomePage from "../pages/home/HomePage";
import ErrorsPage from "../pages/errors/ErrorsPage";
import LogoutPage from "../pages/auth/Logout";
import { LayoutContextProvider } from "../../_metronic";
import Layout from "../../_metronic/layout/Layout";
import AuthPage from "../pages/auth/AuthPage";
import ForgotPassword from "../pages/password/ForgotPassword";
import PrimeiroAcesso from "../pages/auth/PrimeiroAcesso";
import HeaderAuth from "../components/HeaderAuth";

export const Routes = withRouter(({ history }) => {
	const { isAuthorized, user, menuConfig } = useSelector(
		({ auth, builder: { menuConfig } }) => ({
			menuConfig,
			isAuthorized: auth.user != null,
			user: auth.user,
		}),
		shallowEqual
	);
	const pathname = useLocation().pathname;
	const primeiroAcessoPending = Boolean(user?.usr_primeiro_acesso);

	return (
		<LayoutContextProvider history={history} menuConfig={menuConfig}>
			<Switch>
				<Route path="/error" component={ErrorsPage} />
				<Route path="/logout" component={LogoutPage} />

				{!isAuthorized && pathname === "/password/forgot" ? <Route path="/password/forgot" component={ForgotPassword} /> : null}

				{!isAuthorized ? <Route component={AuthPage} /> : null}

				{isAuthorized ? (
					<Route
						path="/auth/primeiro-acesso"
						render={() =>
							primeiroAcessoPending ? (
								<div className="login flex-column">
									<HeaderAuth />
									<PrimeiroAcesso />
								</div>
							) : (
								<Redirect to="/inicio" />
							)
						}
					/>
				) : null}

				{isAuthorized && primeiroAcessoPending ? (
					<Redirect to="/auth/primeiro-acesso" />
				) : null}

				{isAuthorized && !primeiroAcessoPending ? (
					<Route
						render={() => (
							<Layout>
								<HomePage />
							</Layout>
						)}
					/>
				) : null}

				{!isAuthorized ? <Redirect to="/auth/login" /> : null}
			</Switch>
		</LayoutContextProvider>
	);
});
